export const environment = {
  production: false,
  coreApiUrl: 'https://api.dev.commander.lionheart.land/',
  pageTitle: '[Dev] Commander',
  azureSsoAccountId: '',
  azureSsoAppId: '',
  redirectUri: 'https://dev.commander.lionheart.land',
  postLogoutRedirectUri: 'https://dev.commander.lionheart.land',
};